<template>
  <!-- navigate bar top -->
  <el-row>
      <el-row type="flex" align="middle" style="height: 60px;">
          <el-col :span="1">
              <svg t="1492500959545" @click="sidebarToggleClick" viewBox="0 0 1024 1024"
                   version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1691" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20">
                  <path d="M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z"
                        p-id="1692" fill="#313a46"></path>
                  <path d="M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z"
                        p-id="1693" fill="#313a46"></path>
                  <path d="M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z"
                        p-id="1694" fill="#313a46"></path>
              </svg>
          </el-col>

          <el-col :span="6">
              <el-breadcrumb separator="/" style="float: left;">
                  <el-breadcrumb-item :to="{ path: '/base/server/index' }">首页</el-breadcrumb-item>
                  <el-breadcrumb-item v-for="item in routerMatchedArray" :key="item.name" v-if="!!item.meta">{{item.meta.title}}</el-breadcrumb-item>
              </el-breadcrumb>
          </el-col>

          <el-col :offset="18" :span="2" style="padding-left: 45px;">
              <el-dropdown class="avatar-container" trigger="click">
                  <div class="avatar-wrapper">
                      <svg-icon icon-class="person" style="font-size:25px;"/>
                  </div>
                  <el-dropdown-menu class="user-dropdown" slot="dropdown">
                      <el-dropdown-item>德启智能</el-dropdown-item>
                      <router-link class="inlineBlock" to="/login">
                          <el-dropdown-item style="text-align: center;">退出</el-dropdown-item>
                      </router-link>
                  </el-dropdown-menu>
              </el-dropdown>
          </el-col>
      </el-row>
    </el-row>
</template>

<script>
    export default {
        name: "navigateBarTop",
        created(){
            this.showMenuInfo(this.$route);
        },
        watch: {
            $route(to){
                this.showMenuInfo(to);
            }
        },
        data() {
          return{
              routeName: this.$route.name,
              currentRoute: Object,
              routerMatchedArray: Object
          }
        },
        methods: {
            sidebarToggleClick(){
                this.$emit('sidebarToggle');
            },
            showMenuInfo(toRoute) {
                this.routerMatchedArray = toRoute.matched;
                this.currentRoute = this.routerMatchedArray[this.routerMatchedArray.length-1];
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/NavibarTop.vue